import { Type } from '@angular/core';
import { Appointment, Journey } from './appointment.models';
import { Task } from './task.models';

export interface Timeslot {
  start: string;
  end: string;
  text: string;
  shortText: string;
  events: Event[];
}

/**
 * 'Mañana' -> Por la mañana De 07:00 a 11:00
 * 'Media Mañana' -> A media mañana De 11:00 a 13:00
 * 'Mediodía' -> Al mediodía De 13:00 a 16:00
 * 'Tarde' -> Por la tarde De 16:00 a 20:00
 * 'Noche' -> Por la noche De 20:00 a 07:00
 * MACROSAD:
 * 'Noche' -> Por la noche De 20:00 a 23:00
 * 'Cuidados nocturnos' -> Cuidados nocturnos De 23:00 a 07:00
 */

export const ALL_TIMESLOTS: Timeslot[] = [
  {
    start: '0',
    end: '0',
    text: 'SCHEDULE.MODELS.TIMESLOT.THROUGHOUT_THE_DAY.FULL',
    shortText: 'SCHEDULE.MODELS.TIMESLOT.THROUGHOUT_THE_DAY.SHORT',
    events: [],
  },
  {
    start: '7',
    end: '11',
    text: 'SCHEDULE.MODELS.TIMESLOT.MORNING.FULL',
    shortText: 'SCHEDULE.MODELS.TIMESLOT.MORNING.SHORT',
    events: [],
  },
  {
    start: '11',
    end: '13',
    text: 'SCHEDULE.MODELS.TIMESLOT.MID-MORNING.FULL',
    shortText: 'SCHEDULE.MODELS.TIMESLOT.MID-MORNING.SHORT',
    events: [],
  },
  {
    start: '13',
    end: '16',
    text: 'SCHEDULE.MODELS.TIMESLOT.NOON.FULL',
    shortText: 'SCHEDULE.MODELS.TIMESLOT.NOON.SHORT',
    events: [],
  },
  {
    start: '16',
    end: '20',
    text: 'SCHEDULE.MODELS.TIMESLOT.AFTERNOON.FULL',
    shortText: 'SCHEDULE.MODELS.TIMESLOT.AFTERNOON.SHORT',
    events: [],
  },
  {
    start: '20',
    end: '23',
    text: 'SCHEDULE.MODELS.TIMESLOT.NIGHT.FULL',
    shortText: 'SCHEDULE.MODELS.TIMESLOT.NIGHT.SHORT',
    events: [],
  },
  {
    start: '23',
    end: '7',
    text: 'SCHEDULE.MODELS.TIMESLOT.NIGHT_CARES.FULL',
    shortText: 'SCHEDULE.MODELS.TIMESLOT.NIGHT_CARES.SHORT',
    events: [],
  },
];

export type timeslotText =
  | 'TAREAS ASOCIADAS a la jornada 1 VEZ/dia'
  | 'Mañana'
  | 'Media Mañana'
  | 'Mediodía'
  | 'Tarde'
  | 'Noche'
  | 'Cuidados nocturnos';

export const timeslotRelation = {
  'TAREAS ASOCIADAS a la jornada 1 VEZ/dia': ALL_TIMESLOTS[0],
  Mañana: ALL_TIMESLOTS[1],
  'Media Mañana': ALL_TIMESLOTS[2],
  Mediodía: ALL_TIMESLOTS[3],
  Tarde: ALL_TIMESLOTS[4],
  Noche: ALL_TIMESLOTS[5],
  'Cuidados Nocturnos': ALL_TIMESLOTS[6],
};

export type Event = Appointment | Task | Journey;

export type EventFilter = 'all' | 'appointments' | 'tasks';

export interface MarkArticleResponse {
  'success?': boolean;
  message: string;
}
export interface TimeOrderedComponent {
  orderBy: { datetime: Date; order: number };
  data: any;
  component: Type<any>;
}
